import { render, staticRenderFns } from "./AddDocumentVersionDialog.vue?vue&type=template&id=67ac7f4d&scoped=true"
import script from "./AddDocumentVersionDialog.vue?vue&type=script&lang=js"
export * from "./AddDocumentVersionDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentVersionDialog.vue?vue&type=style&index=0&id=67ac7f4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac7f4d",
  null
  
)

export default component.exports